<template>
    <ul class="nav--company">
        <router-link tag="li" :to="{ name: 'Client Company' }" :class="{'active': this.$route.name === 'Client Company'}">
            <a href="#">{{ t('general.settings') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'Client Company Subscription' }" :class="{'active': this.$route.name === 'Client Company Subscription'}">
            <a href="#">{{ t('clients.company.subscription') }}</a>
        </router-link>
        <!-- <router-link tag="li" :to="{ name: 'Clients Connections Brands' }" :class="{'active': this.$route.name === 'Clients Connections Brands'}">
            <a href="#">{{ t('general.brands') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'Clients Connections Attributes' }" :class="{'active': this.$route.name === 'Clients Connections Attributes' || this.$route.name === 'Clients Connections Attributes Add' || this.$route.name === 'Clients Connections Attributes Edit'}">
            <a href="#">{{ t('general.attributes') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'Clients Connections Pricing' }" :class="{'active': this.$route.name === 'Clients Connections Pricing' || this.$route.name === 'Clients Connections Pricing Add' || this.$route.name === 'Clients Connections Pricing Edit'}">
            <a href="#">{{ t('general.prices') }}</a>
        </router-link> -->
    </ul>
</template>

<script>

export default {
    name: 'MyCompanyMenu',

    props: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},
};
</script>

<style lang="scss" scoped>

    a {
        padding-bottom: 1px;
    }

    a:hover {
        text-decoration: none !important;
    }

    li:hover {
        border: 0px;
    }


</style>
